export default __webpack_public_path__ + "static/media/parcell.75d7aa64.svg";